"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCheckPhoneChangeResponseDto = instanceOfCheckPhoneChangeResponseDto;
exports.CheckPhoneChangeResponseDtoFromJSON = CheckPhoneChangeResponseDtoFromJSON;
exports.CheckPhoneChangeResponseDtoFromJSONTyped = CheckPhoneChangeResponseDtoFromJSONTyped;
exports.CheckPhoneChangeResponseDtoToJSON = CheckPhoneChangeResponseDtoToJSON;
exports.CheckPhoneChangeResponseDtoToJSONTyped = CheckPhoneChangeResponseDtoToJSONTyped;
/**
 * Check if a given object implements the CheckPhoneChangeResponseDto interface.
 */
function instanceOfCheckPhoneChangeResponseDto(value) {
    if (!('available' in value) || value['available'] === undefined)
        return false;
    return true;
}
function CheckPhoneChangeResponseDtoFromJSON(json) {
    return CheckPhoneChangeResponseDtoFromJSONTyped(json, false);
}
function CheckPhoneChangeResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'available': json['available'],
    };
}
function CheckPhoneChangeResponseDtoToJSON(json) {
    return CheckPhoneChangeResponseDtoToJSONTyped(json, false);
}
function CheckPhoneChangeResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'available': value['available'],
    };
}
